export default "__VITE_ASSET__C5TKgKRU__"